// Presentation milestones only. Minting, payment and access decisions stay in their existing flows.
export function getLegacyMintStages(steps, { collectionId, hasPageList }) {
    return [
        { label: 'Upload artwork to Irys', done: steps.imageUploaded || steps.nftCreated },
        { label: 'Upload NFT metadata to Irys', done: steps.metadataUploaded || steps.nftCreated },
        // Both transfers share the mint transaction. A zero fee is not an incomplete payment.
        { label: 'Confirm mint price and included commission', done: steps.nftCreated },
        { label: 'Create the Core NFT on Solana', done: steps.nftCreated },
        { label: 'Set the creator update delegate', done: steps.setUpdateDelegate },
        { label: 'Apply configured royalties', done: steps.setRoyalties },
        { label: collectionId ? 'Register NFT in the selected collection and Space token list' : 'Update NFT and Space token lists',
            done: collectionId ? steps.nftCreated : steps.addedToNftList && (!hasPageList || steps.addedToPageList) },
    ];
}

const OFFER_STAGES = [
    'Validate the collectible and wallet',
    'Prepare artwork and metadata',
    'Reserve the edition and prepare the transaction',
    'Approve or resume the wallet transaction',
    'Confirm the transaction on Solana',
    'Record the mint and update edition counts',
    'Deliver the NFT to your wallet',
];
export function getOfferMintStages(completed) {
    return OFFER_STAGES.map((label, index) => ({ label, done: index < completed }));
}
